/**
 * Chain context hooks.
 * Exported from a dedicated file to satisfy react-refresh/only-export-components —
 * hooks cannot live in the same file as the ChainProvider component.
 */

import { useContext } from 'react';

import { ChainContext } from './chainContextDef';

export function useChainContext() {
  const context = useContext(ChainContext);
  if (!context) {
    throw new Error('useChainContext must be used within ChainProvider');
  }

  return context;
}

/**
 * Convenience hook to get just the selected chain
 */
export function useSelectedChain() {
  const { selectedChain, isLoadingChains } = useChainContext();

  return { selectedChain, isLoading: isLoadingChains };
}

/**
 * Convenience hook to get chain selection actions
 */
export function useChainSelection() {
  const {
    enabledChains,
    selectedChain,
    setSelectedChain,
    setSelectedChainById,
    isLoadingChains,
  } = useChainContext();

  return {
    chains: enabledChains,
    selectedChain,
    setSelectedChain,
    setSelectedChainById,
    isLoading: isLoadingChains,
  };
}
